import { Button } from "@mui/material";
import { Container, StyledParagraph, StyledSpan } from "./ErrorDisplay.styles";
import { useNavigate } from "react-router-dom";

export interface ErrorDisplayProps {
  title?: string;
  message?: string;
}

export function ErrorDisplay({ title, message }: ErrorDisplayProps) {
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    navigate("/app/dashboard");
    window.location.reload();
  };

  return (
    <Container>
      <StyledParagraph>{title || "Error rendering component"}</StyledParagraph>
      <StyledSpan>{message || "Something went wrong"}</StyledSpan>
      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "20px" }}
        onClick={navigateToDashboard}
      >
        Back to home
      </Button>
    </Container>
  );
}
